<script>
    import Icon from '../icons/Icon.svelte';

    export let isOpen = false;
    export let store = null;
    export let isDeleting = false;
    export let onConfirmDelete = () => {};
    export let onClose = () => {};
</script>

{#if isOpen && store}
    <div class="modal-overlay" on:click|self={onClose}>
        <div class="modal-card">
            <header class="modal-header">
                <div class="header-icon-box">
                    <Icon name="alert-triangle" size={28} />
                </div>
                <h3>Excluir Estabelecimento?</h3>
                <p>Esta ação é <strong>irreversível</strong> e apagará permanentemente todos os produtos, pedidos e dados associados a este restaurante.</p>
            </header>

            <div class="store-summary">
                <div class="summary-row">
                    <span class="label">Restaurante:</span>
                    <strong>{store.name}</strong>
                </div>
                <div class="summary-row">
                    <span class="label">E-mail:</span>
                    <span class="font-mono">{store.email}</span>
                </div>
                <div class="summary-row">
                    <span class="label">Link:</span>
                    <span class="font-mono">/cardapio/{store.slug}</span>
                </div>
            </div>

            <footer class="modal-footer">
                <button type="button" class="btn-cancel" on:click={onClose} disabled={isDeleting}>
                    Cancelar
                </button>
                <button type="button" class="btn-danger" on:click={onConfirmDelete} disabled={isDeleting}>
                    <Icon name="trash" size={14} />
                    <span>{isDeleting ? 'Excluindo...' : 'Sim, Excluir Restaurante'}</span>
                </button>
            </footer>
        </div>
    </div>
{/if}

<style>
    .modal-overlay {
        position: fixed;
        inset: 0;
        background: rgba(15, 23, 42, 0.6);
        backdrop-filter: blur(4px);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
    }

    .modal-card {
        background: #FFFFFF;
        border: 1px solid #FECACA;
        border-radius: 16px;
        width: 100%;
        max-width: 460px;
        box-shadow: 0 20px 45px rgba(0, 0, 0, 0.15);
        padding: 28px;
        display: flex;
        flex-direction: column;
        gap: 18px;
    }

    .modal-header {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .header-icon-box {
        width: 52px;
        height: 52px;
        border-radius: 50%;
        background: #FEE2E2;
        color: #DC2626;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 12px;
    }

    .modal-header h3 {
        font-size: 19px;
        font-weight: 800;
        color: #0F172A;
        margin: 0 0 6px 0;
        letter-spacing: -0.3px;
    }

    .modal-header p {
        font-size: 13px;
        color: #64748B;
        margin: 0;
        line-height: 1.45;
    }

    .modal-header strong {
        color: #DC2626;
    }

    .store-summary {
        background: #F8FAFC;
        border: 1px solid #E2E8F0;
        border-radius: 8px;
        padding: 14px 16px;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .summary-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 13px;
    }

    .summary-row .label {
        color: #64748B;
        font-size: 12px;
        font-weight: 600;
    }

    .summary-row strong {
        color: #0F172A;
        font-weight: 700;
    }

    .font-mono {
        font-family: monospace;
        color: #475569;
    }

    .modal-footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 10px;
        border-top: 1px solid #E2E8F0;
        padding-top: 16px;
    }

    .btn-cancel {
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        color: #475569;
        padding: 8px 16px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.15s ease;
    }

    .btn-cancel:hover {
        background: #F8FAFC;
        color: #0F172A;
    }

    .btn-danger {
        background: #DC2626;
        border: 1px solid #B91C1C;
        color: #FFFFFF;
        padding: 8px 18px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        transition: all 0.15s ease;
        box-shadow: 0 1px 3px rgba(220, 38, 38, 0.25);
    }

    .btn-danger:hover:not(:disabled) {
        background: #B91C1C;
        box-shadow: 0 3px 8px rgba(220, 38, 38, 0.35);
    }

    .btn-danger:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
</style>
